import React from 'react'
import Sidebar from '../../components/SideBar/Sidebar'

import { LayoutProvider } from "../../context/LayoutContext";
import FloatingToggle from "../../components/FloatingToggle/FloatingToggle";
import Dock from '../../components/Dock/Dock';

const AppShell = ({ children, route }) => {
  return (
    <>
      <LayoutProvider>
        <div className="sb-app-container">
          <Sidebar route={route} />
          <FloatingToggle />
          {children}
          {/* <Dock /> */}
        </div>
      </LayoutProvider>
    </>
  )
}

export default AppShell